<h2 mat-dialog-title>Editar producto</h2>
<!-- Loader -->
<div *ngIf="loading" class="loader-wrap">
    <div class="spinner"></div>
    <div class="loader-text">Cargando datos…</div>
</div>
<div mat-dialog-content class="space-y-3" *ngIf="!loading">
    <mat-form-field appearance="fill" class="w-full compact dense">
        <mat-icon matPrefix class="icon-sm">label</mat-icon>
        <mat-label>Nombre</mat-label>
        <input matInput [(ngModel)]="editable.name" placeholder="Nombre del producto" />
        <button mat-icon-button matSuffix *ngIf="!!editable.name && !loading" aria-label="Borrar nombre"
            (click)="clearName()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>

    <mat-form-field appearance="fill" class="w-full compact dense">
        <mat-icon matPrefix class="icon-sm">short_text</mat-icon>
        <mat-label>Descripción</mat-label>
        <input matInput [(ngModel)]="editable.description" placeholder="Descripción" />
        <button mat-icon-button matSuffix *ngIf="!!editable.description && !loading" aria-label="Borrar descripción"
            (click)="clearDescription()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>

    <mat-form-field appearance="fill" class="w-full compact dense">
        <mat-icon matPrefix class="icon-sm">attach_money</mat-icon>
        <mat-label>Precio</mat-label>
        <input matInput type="number" [(ngModel)]="editable.sellPrice" min="0" step="0.01" placeholder="0.00" />
        <button mat-icon-button matSuffix
            *ngIf="editable.sellPrice != null && editable.sellPrice !== undefined && !loading"
            aria-label="Borrar precio" (click)="clearPrice()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>

    <!-- Category selector -->
    <mat-form-field appearance="fill" class="w-full compact dense">
        <mat-icon matPrefix class="icon-sm">category</mat-icon>
        <mat-label>Categoría</mat-label>
        <mat-select [(ngModel)]="editable.categoryUuid" (selectionChange)="onCategoryChange()">
            <mat-option *ngFor="let c of categories" [value]="c.uuid">{{ c.name }}</mat-option>
        </mat-select>
    </mat-form-field>

    <!-- Portion / Unit Type selector -->
    <mat-form-field appearance="fill" class="w-full compact dense">
        <mat-icon matPrefix class="icon-sm">restaurant_menu</mat-icon>
        <mat-label>Porción</mat-label>
        <mat-select [(ngModel)]="editable.unitTypeUuid">
            <mat-option *ngFor="let u of unitTypes" [value]="u.uuid">{{ u.name }}</mat-option>
        </mat-select>
    </mat-form-field>

    <!-- Options Management Button -->
    <button mat-stroked-button color="primary" type="button" (click)="openOptionsDialog()" [disabled]="loading"
        class="w-full">
        <mat-icon>list_alt</mat-icon>
        Gestionar Opciones
    </button>

    <!-- Channels Management Button -->
    <button mat-stroked-button color="primary" type="button" (click)="openChannelsDialog()" [disabled]="loading"
        class="w-full">
        <mat-icon>hub</mat-icon>
        Gestionar Canales
    </button>

    <!-- Price history button -->
    <button mat-stroked-button type="button" (click)="openPriceHistoryDialog()" [disabled]="loading" class="w-full">
        <mat-icon>history</mat-icon>
        Historial de precios
    </button>
</div>
<div mat-dialog-actions class="flex justify-end gap-2 pt-4">
    <button mat-stroked-button (click)="onCancel()" [disabled]="loading">Cancelar</button>
    <button mat-flat-button color="primary" (click)="onSave()" [disabled]="loading">Guardar</button>
</div>